export const SELECT_COUNTRY: string = 'selected/SELECT_COUNTRY'
export const SELECT_REGION: string = 'selected/SELECT_REGION'
export const SELECT_LOCALITY: string = 'selected/SELECT_LOCALITY'
export const SELECT_AREA: string = 'selected/SELECT_AREA'
export const SELECT_STREET: string = 'selected/SELECT_STREET'
export const SELECT_HOUSE: string = 'selected/SELECT_HOUSE'
export const SELECT_ENTRY: string = 'selected/SELECT_ENTRY'
export const SELECT_FLAT: string = 'selected/SELECT_FLAT'
